// ------------------------------------
// props 輸入需求 : 
// props.id : 
// props.date : date                                ( 開關按鈕 )
// props.shift : object : { data: array }            (  )
// props.state : 
// ------------------------------------

import React, { useEffect, useState } from 'react'  
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Account from '../../../../actions/Account';
import dataHandler_alert from '../../../../actions/dataHandler_alert';

const RowHISBedState =(props)=>{
    let alerts = props.alerts
    const [row, setRow] = useState([]);
    useEffect(() => {
    const sorted = [...(alerts || [])].sort((a, b) => {
        return new Date(b.timestamp.replace(' ', 'T')) - new Date(a.timestamp.replace(' ', 'T'));
    });
    setRow(sorted);
    }, [alerts]);
    const {t} = useTranslation()
    const store_users_array = useSelector(state => state.store_users.users_array_with_superdoctor)
    function findUser(id=0, array=[]){
        let user = array.filter(res=>res.id === id)[0]
        if(user!==null && user!==undefined){
            return user.last_name+user.first_name
        }else{
            return '-'
        }
    }
    return(
        <div className="max-hig-bs">
            {row.map((row, index)=>{
                let image = dataHandler_alert(row.bedStateAlertLevel, row.bedState).img
                let discription = t(dataHandler_alert(row.bedStateAlertLevel, row.bedState).msg)
                let level = dataHandler_alert(row.bedStateAlertLevel, row.bedState).level
                if((level === props.state)||(props.state==="all")){
                    return( 
                        <div key={index} className="fx-d-r fx-ccc font-ml">
                            {Account.isMobileOrTablet()?null:
                                <div className="col-2 fx-ccc row_body odd">{row.timestamp.split(' ')[0]}</div>                      
                            }
                            <div className="col-2 fx-ccc row_body even">{row.timestamp.split(' ')[1]}</div>
                            <div className="col-2 fx-ccc row_body odd">
                                <img src={image} className='row_img ' alt={discription}/>
                            </div>
                            <div className="col-2 fx-ccc row_body even wrap">{discription}</div>
                            <div className="col-2 fx-ccc row_body odd">{row.resolved_user_id? row.resolved.split(' ')[1]:'-'}</div>
                            <div className="col-2 fx-ccc row_body even">{findUser(row.resolved_user_id, store_users_array)}</div>
                        </div>
                    )
                }
                return null
            })}   
        </div>
    );	

}
export default RowHISBedState;
